import React  from "react";
import { Link } from 'react-router-dom';

import { Date, Money } from '../../components';
import { Visible } from '../../core/components';
import { Button, Card, Icon } from '../../components/ui';
import { Deposit, PaymentOption } from '../atoms';
import { getFileUrl } from '../../core/config/api.js';
import { getBaseCurrency } from "../../core/currency";

export function CheckoutItem({
  item,
  readOnly,
  removeItem,
  toggleDeposit,
  isOrderPaid,
}) {
  const listing = item.listing;
  const product = listing.product

  const hasDeposits = item.paidDeposits?.length > 0 || item.availableDeposits?.length > 0;

  return (
    <Card className="checkout-item">
      <div className="checkout-item__main">
        <img className="checkout-item__image" src={getFileUrl(product.images[0].id)} alt="" />

        <div className="checkout-item__body">
          <div className="checkout-item__head">
            <div>
              <Link to={"/product/" + listing.id} className="checkout-item__link">
                <h5 className="checkout-item__title">{product.brand.name} {product.model.name}</h5>
              </Link>

              <p className="checkout-item__reference">{product.reference_number}</p>
            </div>

            {/* Storefront items are priced in the listing currency, falling back
                to the store base (listings carry no currency column today). */}
            <Money amount={item.quantity * item.price} currency={listing.currency ?? getBaseCurrency()} className="checkout-item__price" />
          </div>

          <div className="checkout-item__foot">
            {/* Never editable here — the quantity renders as the count it is.
                Shown for the same cases the disabled input used to cover: always
                while the order is open, and only when it carries information
                (> 1) once it is read-only. */}
            {(!readOnly || item.quantity > 1) && (
              <span className="checkout-item__quantity">{item.quantity}</span>
            )}

            {!readOnly && !item.paidAmount && (
              <Button
                variant="ghost"
                size="sm"
                onClick={removeItem}
                leadingIcon={<Icon name="Trash2" size="sm" />}
              >
                Remove product
              </Button>
            )}
          </div>
        </div>
      </div>

      <Visible when={hasDeposits && !isOrderPaid}>
        <div className="checkout-item__deposits">
          <Visible when={item.paidDeposits?.length}>
            <div className="checkout-deposits">
              <h6 className="checkout-deposits__heading">Payment Done</h6>

              {item?.paidDeposits?.map(deposit => (
                <PaymentOption key={deposit.id}>
                  Deposit amount of
                  <Money amount={deposit.amount} currency={deposit.currency ?? listing.currency ?? getBaseCurrency()} className="checkout-item__price" />
                  on&nbsp;
                  <Date date={deposit.date} />
                </PaymentOption>
              ))}
            </div>

            <div className="checkout-deposits">
              <h6 className="checkout-deposits__heading">Remaining</h6>

              <PaymentOption>
                <Money amount={item.price - item.paidAmount} currency={listing.currency ?? getBaseCurrency()} className="checkout-item__price" />
              </PaymentOption>
            </div>
          </Visible>

          <Visible when={item?.availableDeposits?.length}>
            <div className="checkout-deposits">
              <h6 className="checkout-deposits__heading">Deposits</h6>

              <div className="checkout-deposits__chips">
                {item?.availableDeposits?.map(deposit => (
                  <Deposit
                    key={deposit.name}
                    amount={deposit.amount}
                    currency={deposit.currency ?? listing.currency ?? getBaseCurrency()}
                    selected={deposit.selected}
                    disabled={deposit.disabled}
                    onClick={() => toggleDeposit(deposit)}
                  />
                ))}
              </div>
            </div>
          </Visible>
        </div>
      </Visible>
    </Card>
  );
}
